import styled from 'styled-components';
import tw from 'twin.macro';

const MutualSectionContainer = styled.div`
  ${tw`p-4 pb-0 mb-2`}
`;

const Title = styled.span`
  ${tw`font-bold text-sm mb-3 pr-2`}
`;

const Description = styled.span`
  ${tw`text-sm mb-4`}
`;

const SignatureSection = styled.div`
  ${tw`mt-4 flex flex-row gap-2 pb-2 justify-between`}
`;

const SignatureRow = styled.div`
  ${tw`mb-2 mt-6 flex flex-row pr-4`}
`;

const Label = styled.span`
  ${tw`text-sm`}
`;

const TitleInCenter = styled.div`
  ${tw`text-center mb-6 mt-2 font-bold`}
`;

const MutualAgreementSigns = ({
  title,
  description,
  signerTitle,
  coSignerTitle,
  titleInCenter,
  checkBoxContent,
  children,
  showPrintName,
  showDate,
  footerNote,
  showSignerAddress,
}: {
  title?: string;
  description: string;
  signerTitle?: string;
  coSignerTitle?: string;
  titleInCenter?: string;
  checkBoxContent?: string;
  children?: React.ReactNode;
  showPrintName?: boolean;
  showDate?: boolean;
  footerNote?: React.ReactNode;
  showSignerAddress?: boolean;
}) => {
  const renderSignatureSection = () => {
    if (checkBoxContent) {
      return (
        <SignatureSection>
          <SignatureRow>
            <input type="checkbox" />
            <Label>
              {checkBoxContent}
              _________________________________________________________________
            </Label>
          </SignatureRow>
        </SignatureSection>
      );
    }
    return (
      <SignatureSection>
        <SignatureRow>
          <Label>{signerTitle ? `${signerTitle}` : 'Buyer Signs X'}</Label>
          {showDate ? (
            <>
              <div>______________________</div>
              <div>Date: ______________</div>
            </>
          ) : (
            <div>_______________________________________</div>
          )}
        </SignatureRow>
        <SignatureRow>
          <Label>{coSignerTitle ? `${coSignerTitle}` : 'Co-Buyer Signs X'}</Label>
          {showDate ? (
            <>
              <div>______________________</div>
              <div>Date: ______________</div>
            </>
          ) : (
            <div>_______________________________________</div>
          )}
        </SignatureRow>
      </SignatureSection>
    );
  };

  const renderPrintNameSection = () => {
    return (
      <SignatureSection>
        {showPrintName && (
          <SignatureRow>
            <Label>Buyer Printed Name</Label>
            <div>____________________________________</div>
          </SignatureRow>
        )}
        {showPrintName && (
          <SignatureRow>
            <Label>Co-Buyer Printed Name</Label>
            <div>____________________________________</div>
          </SignatureRow>
        )}
      </SignatureSection>
    );
  };
  return (
    <MutualSectionContainer>
      {title && <Title>{title}</Title>}
      {titleInCenter && <TitleInCenter>{titleInCenter}</TitleInCenter>}
      {children && children}
      <Description>{description}</Description>
      {renderSignatureSection()}
      {showPrintName && renderPrintNameSection()}
      {footerNote && footerNote}
      {showSignerAddress && (
        <>
          <SignatureSection>
            <SignatureRow>
              <Label>Date</Label>
              <div>____________________________________</div>
            </SignatureRow>

            <SignatureRow>
              <Label>Date</Label>
              <div>____________________________________</div>
            </SignatureRow>
          </SignatureSection>
          <SignatureSection>
            <SignatureRow>
              <Label>{signerTitle ? `${signerTitle}` : 'Buyer'} Address</Label>
              <div>____________________________________</div>
            </SignatureRow>

            <SignatureRow>
              <Label>{coSignerTitle ? `${coSignerTitle}` : 'Co-Buyer'} Address</Label>
              <div>____________________________________</div>
            </SignatureRow>
          </SignatureSection>
        </>
      )}
    </MutualSectionContainer>
  );
};

export default MutualAgreementSigns;
